import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-711bb1be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Add ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_button = _resolveComponent("default-button")!
  const _component_targeting_selector = _resolveComponent("targeting-selector")!

  return (_openBlock(), _createElementBlock("section", null, [
    _renderSlot(_ctx.$slots, "info", {}, undefined, true),
    _createVNode(_component_default_button, {
      onActivate: _ctx.searchForTargeting,
      disabled: _ctx.disableSearch,
      class: "small-button-search"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onActivate", "disabled"]),
    _createVNode(_component_default_button, {
      onActivate: _ctx.addTargeting,
      disabled: _ctx.noTargetSelected,
      class: "small-button-add"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onActivate", "disabled"]),
    _createVNode(_component_targeting_selector, {
      ref: "child",
      id: _ctx.id,
      targetingOptions: _ctx.options,
      loading: _ctx.searchIsLoading,
      searchPlaceholder: _ctx.targetingPlaceholder,
      onSearch: _ctx.updateSearchQuery,
      onEmptySearch: _ctx.emptySearch,
      onSelect: _ctx.select
    }, null, 8, ["id", "targetingOptions", "loading", "searchPlaceholder", "onSearch", "onEmptySearch", "onSelect"])
  ]))
}